import { unwrapResult } from '@reduxjs/toolkit'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { fetchProjectDetails } from 'redux/project/project-details'
import { selectIsProjectAdmin } from 'redux/project/project-details/ProjectDetails.selectors'
import { useAppDispatch } from 'redux/store'
import useProjectId from './useProjectId'

const useProjectDetailsRedirection = (redirectWithWhenNoProjectAdmin = false): void => {
  const history = useHistory()
  const dispatch = useAppDispatch()
  const [detailsLoaded, setDetailsLoaded] = useState(false)
  const isProjectAdmin = useSelector(selectIsProjectAdmin)
  const projectId = useProjectId()
  useEffect(() => {
    // project's details loaded but no admin access
    if (detailsLoaded && redirectWithWhenNoProjectAdmin && isProjectAdmin === false) {
      history.replace('/')
    }
  }, [history, isProjectAdmin, detailsLoaded, redirectWithWhenNoProjectAdmin])
  useEffect(() => {
    const projectIdNumber = Number(projectId)
    const isProjectIdNumber = !Number.isNaN(projectIdNumber)
    if (projectId && isProjectIdNumber) {
      dispatch(fetchProjectDetails(projectIdNumber))
        .then(unwrapResult)
        .then(() => setDetailsLoaded(true))
        .catch(() => history.replace('/'))
    }
    if (!isProjectIdNumber) history.replace('/')
  }, [dispatch, projectId, history])
}

export default useProjectDetailsRedirection
